exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-c761afbe]{margin:0!important}.txt-primary[data-v-c761afbe]{color:#ff5722}.txt-sub3[data-v-c761afbe]{color:#828282}.txt-body2[data-v-c761afbe]{color:$body2}.lp-add-pay-type-container[data-v-c761afbe]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;cursor:pointer}.add-box[data-v-c761afbe]{position:relative;border:1px solid #ccc;border-radius:2px;margin-right:8px;text-align:center;background-color:#fff}", ""]);

// exports
